<template>
  <span class="badge">{{ showNumber }}</span>
</template>

<script>
export default {
  props: {
    value: [Number, String],
  },

  computed: {
    showNumber() {
      const { value } = this;

      return value > 99 ? '99+' : value;
    },
  },
};
</script>

<style lang="scss" scoped>
.badge {
  background: #ff4251;
  color: #fff;
  min-width: 10px;
  padding: 3px 7px;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
  line-height: 1;
  vertical-align: middle;
  white-space: nowrap;
  text-align: center;
  border-radius: 10px;
}
</style>